export const applyPolyfills = async () => {
    try {
        // String.replaceAll polyfill
        if (!String.prototype.replaceAll) {
            console.info('Add String.replaceAll polyfill');
            const replaceAllPolyfill = await import('string.prototype.replaceall');
            replaceAllPolyfill.shim();
        }

        // Intl.Locale polyfill
        if (!("Locale" in Intl)) {
            console.info('Add Intl.Locale polyfill');
            await import('@formatjs/intl-locale/polyfill.js');
        }

        // Intl.PluralRules polyfill
        if (!("PluralRules" in Intl)) {
            console.info('Add Intl.PluralRules polyfill');
            await import('@formatjs/intl-pluralrules/polyfill.js');
            await import(`@formatjs/intl-pluralrules/locale-data/en`);
            await import(`@formatjs/intl-pluralrules/locale-data/fr`);
            await import(`@formatjs/intl-pluralrules/locale-data/es`);
            await import(`@formatjs/intl-pluralrules/locale-data/de`);
            await import(`@formatjs/intl-pluralrules/locale-data/it`);
            await import(`@formatjs/intl-pluralrules/locale-data/pl`);
            await import(`@formatjs/intl-pluralrules/locale-data/pt`);
        }

        // Intl.RelativeTimeFormat polyfill
        if (!("RelativeTimeFormat" in Intl)) {
            console.info('Add Intl.RelativeTimeFormat polyfill');
            await import('@formatjs/intl-relativetimeformat/polyfill.js');
            await import('@formatjs/intl-relativetimeformat/locale-data/en');
            await import('@formatjs/intl-relativetimeformat/locale-data/fr');
            await import('@formatjs/intl-relativetimeformat/locale-data/es');
            await import('@formatjs/intl-relativetimeformat/locale-data/de');
            await import('@formatjs/intl-relativetimeformat/locale-data/it');
            await import('@formatjs/intl-relativetimeformat/locale-data/pl');
            await import('@formatjs/intl-relativetimeformat/locale-data/pt');
        }

        // crypto.randomUUID polyfill
        if (!('randomUUID' in crypto)) {
            console.info('Add crypto.randomUUID polyfill');
            // https://stackoverflow.com/a/2117523/2800218
            crypto.randomUUID = function randomUUID() {
                return (
                    [1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g,
                        c => (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
                    );
            };
        }

        // Array.toReversed polyfill (inline: the es-shim dynamic import was not
        // reliably applied on some browsers, cf. Sentry REBORN-FRONT-16M)
        if (!Array.prototype.toReversed) {
            console.info('Add Array.toReversed polyfill');
            Object.defineProperty(Array.prototype, 'toReversed', {
                configurable: true,
                writable: true,
                enumerable: false,
                value: function toReversed() {
                    return Array.prototype.slice.call(this).reverse();
                },
            });
        }

    } catch (err) {
        console.error('Polyfill setup error', err);
    }
}
